<app-shared-dialog
  [title]="dialogTitle"
  [options]="dialogOptions"
  (cancel)="close()">
  <div class="role-form-dialog__body">
    <ui-form-field
      [formControl]="roleNameControl"
      [placeholder]="'settings.role_name' | translate"
      [errorMessages]="{ required: 'validation.required' | translate }">
    </ui-form-field>
  </div>

  <div customConfirm>
    <ui-button
      type="primary"
      [label]="saveLabel | uppercase"
      [icon]="isEditMode ? 'pen-cc' : 'plus-cc'"
      iconPosition="start"
      [isLoading]="isSubmitting"
      [disabled]="isFormInvalid || isSubmitting"
      (click)="submitForm()">
    </ui-button>
  </div>
</app-shared-dialog>
